import {
  ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS,
  ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_EDIT_ITEM,
  ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_ITEM,
  ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_NEW_ITEM,
  ROUTE_ADMIN_CONFIG_PAGE_ROOM,
  ROUTE_ADMIN_CONFIG_PAGE_ROOM_EDIT_SOCIAL_NETWORK,
  ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM,
  ROUTE_ADMIN_CONFIG_PAGE_ROOM_NEW_SOCIAL_NETWORK,
  ROUTE_ADMIN_CONTENT_MANAGEMENT,
  ROUTE_ADMIN_FOOTER_OBJECTS,
  ROUTE_ADMIN_FOOTER_OBJECTS_ITEM,
  ROUTE_ADMIN_HEADER_OBJECTS,
  ROUTE_ADMIN_HEADER_OBJECTS_ITEM,
  ROUTE_ADMIN_HEADER_PAGE_EDIT_ITEM_NAVIGATION_BAR,
  ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR,
  ROUTE_ADMIN_HEADER_PAGE_NEW_ITEM_NAVIGATION_BAR,
  ROUTE_ADMIN_HEADER_PAGE_NEW_NAVIGATION_BAR,
  ROUTE_ADMIN_HOME_EDIT_LINKS_OF_INTEREST,
  ROUTE_ADMIN_HOME_NEW_LINKS_OF_INTEREST,
  ROUTE_ADMIN_HOME_PAGE,
  ROUTE_ADMIN_HOME_PAGE_EDIT_TAX_ACCESS_BUTTON,
  ROUTE_ADMIN_HOME_PAGE_ITEM,
  ROUTE_ADMIN_HOME_PAGE_NEW_TAX_ACCESS_BUTTON,
  ROUTE_ADMIN_NEWS_PAGE,
  ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS,
  ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_EDIT_USER,
  ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_NEW_USER,
  ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT,
  ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT_NEW_ROLE,
  ROUTE_ADMIN_PARAMETRIZATION_SECURITY,
  ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS,
  ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_EDIT,
  ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_NEW,
  ROUTE_ADMIN_PARAMETRIZATION_THEMES,
  ROUTE_ADMIN_PARTICIPATES_PAGE,
  ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM,
  ROUTE_ADMIN_PQRSD_PAGE,
  ROUTE_ADMIN_PQRSD_PAGE_EDIT,
  ROUTE_ADMIN_PRESS_ROOM,
  ROUTE_ADMIN_REGULATIONS_PAGE,
  ROUTE_ADMIN_SERVICES_PAGE,
  ROUTE_ADMIN_SERVICES_PAGE_ITEM,
  ROUTE_ADMIN_TRANSPARENCY_PAGE,
  ROUTE_ADMIN_TRANSPARENCY_PAGE_EDIT_ITEM_TRANSPARENCY_ACCORDION,
  ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM,
  ROUTE_ADMIN_TRANSPARENCY_PAGE_NEW_ITEM_TRANSPARENCY_ACCORDION,
  ROUTE_ADMIN_VERSION_PAGE_PAGE_VERSION,
  ROUTE_DYNAMIC_PAGES_MANAGEMENT,
  ROUTE_DYNAMIC_PAGES_MANAGEMENT_EDIT,
  ROUTE_DYNAMIC_PAGES_MANAGEMENT_NEW,
  ROUTE_EVENT_MANAGEMENT,
  ROUTE_INSTITUTIONAL_PROGRAMS_MANAGEMENT,
  ROUTE_PARTICIPATE_CONTENT_MANAGEMENT,
  ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_EDIT,
  ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_NEW,
  ROUTE_PARTICIPATE_MANAGEMENT,
  ROUTE_PARTICIPATE_MANAGEMENT_EDIT_REGULATION,
  ROUTE_PARTICIPATE_MANAGEMENT_NEW_REGULATION,
  ROUTE_PQRSD_CONTENT_MANAGEMENT,
  ROUTE_PQRSD_CONTENT_MANAGEMENT_EDIT,
  ROUTE_PQRSD_CONTENT_MANAGEMENT_NEW,
  ROUTE_PRESS_ROOM_MANAGEMENT,
  ROUTE_PROCEDURES_SERVICES_MANAGEMENT,
  ROUTE_REGULATION_MANAGEMENT,
  ROUTE_REGULATION_MANAGEMENT_EDIT,
  ROUTE_REGULATION_MANAGEMENT_NEW,
} from '@/utils/constants';

const ROUTES_THREE = [
  {
    index: 0,
    routes: [ROUTE_ADMIN_VERSION_PAGE_PAGE_VERSION],
  },
  {
    index: 1,
    routes: [
      ROUTE_ADMIN_HEADER_OBJECTS,
      ROUTE_ADMIN_HEADER_OBJECTS_ITEM,
      ROUTE_ADMIN_FOOTER_OBJECTS,
      ROUTE_ADMIN_FOOTER_OBJECTS_ITEM,
      ROUTE_ADMIN_HOME_PAGE,
      ROUTE_ADMIN_HOME_PAGE_ITEM,
      ROUTE_ADMIN_HEADER_PAGE_NEW_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_EDIT_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_NEW_ITEM_NAVIGATION_BAR,
      ROUTE_ADMIN_HEADER_PAGE_EDIT_ITEM_NAVIGATION_BAR,
    ],
  },
  {
    index: 7,
    routes: [
      ROUTE_ADMIN_TRANSPARENCY_PAGE,
      ROUTE_ADMIN_SERVICES_PAGE,
      ROUTE_ADMIN_PARTICIPATES_PAGE,
      ROUTE_ADMIN_NEWS_PAGE,
      ROUTE_ADMIN_HOME_NEW_LINKS_OF_INTEREST,
      ROUTE_ADMIN_HOME_EDIT_LINKS_OF_INTEREST,
      ROUTE_ADMIN_HOME_PAGE_NEW_TAX_ACCESS_BUTTON,
      ROUTE_ADMIN_HOME_PAGE_EDIT_TAX_ACCESS_BUTTON,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_ITEM,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_NEW_SOCIAL_NETWORK,
      ROUTE_ADMIN_CONFIG_PAGE_ROOM_EDIT_SOCIAL_NETWORK,
      ROUTE_ADMIN_SERVICES_PAGE,
      ROUTE_ADMIN_SERVICES_PAGE_ITEM,
      ROUTE_ADMIN_PARTICIPATES_PAGE,
      ROUTE_ADMIN_PARTICIPATES_PAGE_ITEM,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_ITEM,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_EDIT_ITEM_TRANSPARENCY_ACCORDION,
      ROUTE_ADMIN_TRANSPARENCY_PAGE_NEW_ITEM_TRANSPARENCY_ACCORDION,
      ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS,
      ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_ITEM,
      ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_NEW_ITEM,
      ROUTE_ADMIN_CONFIG_PAGE_INSTITUTIONAL_PROGRAMS_EDIT_ITEM,
      ROUTE_ADMIN_REGULATIONS_PAGE,
    ],
  },
  {
    index: 2,
    routes: [
      ROUTE_REGULATION_MANAGEMENT,
      ROUTE_REGULATION_MANAGEMENT_NEW,
      ROUTE_REGULATION_MANAGEMENT_EDIT,
      ROUTE_DYNAMIC_PAGES_MANAGEMENT,
      ROUTE_DYNAMIC_PAGES_MANAGEMENT_NEW,
      ROUTE_DYNAMIC_PAGES_MANAGEMENT_EDIT,
      ROUTE_PQRSD_CONTENT_MANAGEMENT,
      ROUTE_PQRSD_CONTENT_MANAGEMENT_NEW,
      ROUTE_PQRSD_CONTENT_MANAGEMENT_EDIT,
      ROUTE_ADMIN_CONTENT_MANAGEMENT,
      ROUTE_ADMIN_PRESS_ROOM,
      ROUTE_PRESS_ROOM_MANAGEMENT,
      ROUTE_PROCEDURES_SERVICES_MANAGEMENT,
      ROUTE_PARTICIPATE_MANAGEMENT,
      ROUTE_PARTICIPATE_MANAGEMENT_NEW_REGULATION,
      ROUTE_PARTICIPATE_MANAGEMENT_EDIT_REGULATION,
      ROUTE_PARTICIPATE_CONTENT_MANAGEMENT,
      ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_NEW,
      ROUTE_PARTICIPATE_CONTENT_MANAGEMENT_EDIT,
      ROUTE_EVENT_MANAGEMENT,
      ROUTE_INSTITUTIONAL_PROGRAMS_MANAGEMENT,
    ],
  },
  {
    index: 3,
    routes: [ROUTE_ADMIN_PQRSD_PAGE, ROUTE_ADMIN_PQRSD_PAGE_EDIT],
  },
  {
    index: 6,
    routes: [
      ROUTE_ADMIN_PARAMETRIZATION_THEMES,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_NEW,
      ROUTE_ADMIN_PARAMETRIZATION_SYSTEM_PARAMETERS_EDIT,
      ROUTE_ADMIN_PARAMETRIZATION_SECURITY,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_NEW_USER,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_NEW_USER,
      ROUTE_ADMIN_PAGE_SECURITY_ACCOUNT_USERS_EDIT_USER,
      ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT,
      ROUTE_ADMIN_PAGE_SECURITY_ROLE_MANAGEMENT_NEW_ROLE,
    ],
  },
];

export function getCurrentIndexByRoute(route: string) {
  return ROUTES_THREE.find((item) => item.routes.some((subitem) => subitem == route))?.index;
}
